import { rem } from 'polished'
import styled from 'styled-components'

import LoadingAnimation from 'components/Common/Loading/LoadingAnimation'
import { headerHeight } from 'tripPlanner/config'

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  height: calc(100vh - ${rem(71)}); /* Min-height used in App/Header.tsx */
  width: 100vw;
`

const StyledLoadingAnimation = styled(LoadingAnimation)`
  color: ${(props) => props.theme.palette.brand.primary.normal};
  transform: translateY(-${rem(headerHeight.lg)});
`

export default function LoadingPage() {
  return (
    <StyledContainer>
      <StyledLoadingAnimation />
    </StyledContainer>
  )
}
